var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _circle2, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 359,
    height: 232.8,
    "data-name": "Layer 1",
    viewBox: "0 0 790 512.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M720.563 510.693L698 442.603s24.818 24.817 24.818 45.181l-4.454-47.09s12.727 17.18 11.454 43.272-9.255 26.727-9.255 26.727zm-484.543-62L214 382.24s24.222 24.222 24.222 44.096l-4.348-45.96s12.421 16.77 11.18 42.233-9.033 26.085-9.033 26.085z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M579.726 479.359c.037 43.715-86.665 30.268-192.81 30.36s-191.535 13.686-191.573-30.028 86.633-53.298 192.777-53.39 191.568 9.343 191.606 53.058z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "M505.336 420.322h-13.877l-6.604-53.525h20.481v53.525z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M480.006 416.357h28.304v16.851h-43.613v-1.541a15.31 15.31 0 0115.309-15.31z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "M607.336 499.322h-13.877l-6.604-53.525h20.481v53.525z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M582.006 495.357h28.304v16.851h-43.613v-1.541a15.31 15.31 0 0115.309-15.31z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "M671.345 340.309a10.316 10.316 0 00-2.896-15.551l-32.23-131.293-20.608 8.867 38.336 126.949a10.372 10.372 0 0017.398 11.028zM646.208 74.964a11.382 11.382 0 00-17.416 1.152l-49.885 5.727 7.589 19.242 45.367-8.491a11.444 11.444 0 0014.345-17.63z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M564 326.693l21.768 163.374 27.093-5.578s-3.984-118.981 9.563-133.325S605 311.694 605 311.694z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M573 281.693l-10 15s-77-32-77 19-4.406 85.61-6 88 18.438 8.594 28 7c0 0 11.797-82.219 11-87 0 0 75.534 37.033 89.877 33.846S626.61 343.068 629 336.693s-1-57-1-57l-47.81-14.59z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M574.35 191.633l-2.851-3.42s-31.924-71.829-19.382-91.211 67.267-22.233 68.977-21.093-4.084 15.943-.094 22.784c0 0-42.394 9.191-45.244 10.331s21.966 43.274 21.966 43.274l-2.85 25.653z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M630.215 156.289s-29.643 3.42-30.783 3.42-1.71-7.41-1.71-7.41l-26.223 35.913S558.579 292.403 562 290.693s66.505 8.112 67.075 3.551-.57-27.363 1.14-28.503 29.644-71.828 29.644-71.828-2.85-14.822-12.542-19.952-17.102-17.672-17.102-17.672z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M650.738 184.222l9.12 9.69s13.553 111.36 6.142 114.781-22 3-22 3L629.645 258.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 601.73,
    cy: 122.998,
    r: 26.239,
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M595.573 127.092c-.355-5.445-7.223-5.631-12.68-5.683s-11.977.144-15.065-4.355c-2.04-2.973-1.65-7.1.035-10.288s4.458-5.639 7.186-7.997c7.041-6.09 14.298-12.13 22.752-16.027s18.36-5.472 27.128-2.343c10.77 3.843 25.329 23.625 26.586 34.991s-3.285 22.953-10.942 31.446-25.182 5.067-36.21 8.088c6.704-9.49 2.285-26.732-8.456-31.164z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.722,
    cy: 403.505,
    r: 62.989,
    fill: "#6c63ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c63ff",
    d: "M319.656 336.04a45.16 45.16 0 01-41.255-26.787L178.449 84.162a59.83 59.83 0 11111.87-41.865l72.377 235.412a45.08 45.08 0 01-43.04 58.33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5f5b918d35e29b4628a28e96841deeac.svg";
export { ForwardRef as ReactComponent };